import script from "./FuncDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./FuncDetail.vue?vue&type=script&setup=true&lang=js"

import "./FuncDetail.vue?vue&type=style&index=0&id=4f6aa69d&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f6aa69d"]])

export default __exports__